import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import { useTheme } from "../../../../style/theme";
import { FiGrid } from "react-icons/fi";
import { TfiViewList } from "react-icons/tfi";
import AllReporteesGrid from "./AllReporteesGrid";
import DirectReporteesGrid from "./DirectReporteesGrid";
import DirectReporteesTable from "./DirectReporteesTable";
import AllReporteesTable from "./AllReporteeTable";
import { CiSearch } from "react-icons/ci";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import dayjs from "dayjs";

export default function LeaveTrackerReportees() {
  const [view, setView] = useState({ first: "direct", second: "" });
  const [screenView, setScreenView] = useState("grid");
  const { mode } = useTheme();
  const [isExpanded, setIsExpanded] = useState(false);
  const searchRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [shiftEnd, setShiftEnd] = useState("");
  const [shiftStart, setShiftStart] = useState("");
  const [timeRemaining, setTimeRemaining] = useState("");

  let currenrUser = JSON.parse(localStorage.getItem("user"));
  let currentEmp = JSON.parse(localStorage.getItem("emp"));


  const [employeeData, setEmployeeData] = useState([]);
  const fetchEmployees = useCallback(async (employeeSearch = "") => {
    try {
      const response = await axios.get(
        `/hr/employee?pageSize=10${
          employeeSearch ? `&searchBy=firstName&search=${employeeSearch}` : ""
        }`
      );
      const employees = response.data.employees;
      setEmployeeData(employees);
    } catch (e) {
      console.log(e);
    }
  }, []);

  useEffect(() => {
    fetchEmployees();
  }, [fetchEmployees]);

  
  // useEffect(() => {
  //   if (currentEmp) {
  //     const start = currentEmp?.shiftStart;
  //     const end = currentEmp?.shiftEnd;
  //     setShiftStart(formatTime(start?.hour, start?.minute));
  //     setShiftEnd(formatTime(end?.hour, end?.minute));
  //     calculateNextShiftTime(currentEmp?.shiftStart); // Call to calculate next shift on initial load
  //   }
  // }, []);

  // const formatTime = (hour, minute) => {
  //   // Convert hour and minute into proper AM/PM format
  //   const time = dayjs().hour(hour).minute(minute);
  //   return time.format("h:mm A");
  // };

  // const calculateNextShiftTime = (shiftStart) => {
  //   if (!shiftStart) return;

  //   const shiftStartTime = dayjs()
  //     .hour(shiftStart?.hour)
  //     .minute(shiftStart?.minute)
  //     .second(0); // Ensure seconds start at 0

  //   const now = dayjs();
  //   let diff = shiftStartTime.diff(now, "second"); // Get difference in seconds

  //   if (diff < 0) {
  //     diff += 24 * 60 * 60; // Next day's shift
  //   }

  //   const hoursLeft = Math.floor(diff / 3600);
  //   const minutesLeft = Math.floor((diff % 3600) / 60);
  //   const secondsLeft = diff % 60;

  //   setTimeRemaining(
  //     `${formatTimeUnit(hoursLeft)}:${formatTimeUnit(
  //       minutesLeft
  //     )}:${formatTimeUnit(secondsLeft)}`
  //   );
  // };

  // const formatTimeUnit = (unit) => String(unit).padStart(2, "0");

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     if (currentEmp) {
  //       calculateNextShiftTime(currentEmp?.shiftStart); // Recalculate every second
  //     }
  //   }, 1000); // Updates every second

  //   return () => clearInterval(interval); // Cleanup interval on component unmount
  // }, [currentEmp]);


  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setIsExpanded(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleToggle = (newView) => {
    setView({ ...view, first: newView });
  };

  return (
    <div className="h-[100vh]">
      <div className="h-full flex gap-3 flex-col p-2 md:p-3 ">
        <div className="w-full flex flex-row gap-3 justify-center sm:justify-between items-center">
          {isExpanded && (
            <div
              ref={searchRef}
              className="relative transition-all w-full duration-300"
            >
              <TextField
                sx={{ backgroundColor: mode === "light" ? "#fff" : "" }}
                fullWidth
                placeholder="Enter 3 or more characters to search"
                variant="outlined"
                autoFocus
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="transition-all duration-300"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconButton sx={{ backgroundColor: "transparent" }}>
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        sx={{ backgroundColor: "transparent" }}
                        onClick={() => {
                          setIsExpanded(false);
                          setSearchTerm("");
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          )}

          {!isExpanded && (
            <div className="flex gap-3 flex-col md:flex-row justify-between w-full ">
              <div className="flex items-center gap-2">
                <img
                  className="w-10 h-10 rounded-md"
                  src="/images/no-user.png"
                  alt=""
                />
                <p className="text-[14px]">
                  {currenrUser?.firstName} {currenrUser?.lastName}
                </p>
              </div>
              <div className="flex gap-2 items-center">
                <div>
                  <Box className="flex">
                    <button
                      onClick={() => handleToggle("direct")}
                      variant={
                        view.first === "direct" ? "contained" : "outlined"
                      }
                      className={`px-4 py-1 rounded-sm text-[14px] ${
                        view.first === "direct"
                          ? mode === "light"
                            ? "bg-white border border-blue-500 text-black"
                            : "bg-[#3767b1]"
                          : "bg-gray-200 text-black"
                      }`}
                    >
                      Direct {employeeData?.length}
                    </button>
                    <button
                      onClick={() => handleToggle("all")}
                      // variant={view.first === "all" ? "contained" : "outlined"}
                      className={`px-4 py-1 rounded-sm text-[14px] ${
                        view.first === "all"
                          ? mode === "light"
                            ? "bg-white border border-blue-500 text-black"
                            : "bg-[#3767b1]"
                          : "bg-gray-200 text-black"
                      }`}
                    >
                      All {employeeData?.length}
                    </button>
                  </Box>
                </div>
                <div
                  className={`rounded-md flex items-center gap-1  ${
                    mode === "light" ? "bg-[#fff]" : "#171717"
                  }`}
                >
                  <div
                    className="relative group p-1 rounded-md"
                    style={{
                      border: screenView === "grid" ? "1px solid #0088ff" : "",
                    }}
                  >
                    <FiGrid
                      size={20}
                      className="cursor-pointer"
                      onClick={() => setScreenView("grid")}
                      color={screenView === "grid" ? "#0088ff" : ""}
                    />
                    <span className="absolute top-10 left-1/2 w-[max-content] -translate-x-1/2 text-xs bg-gray-800 text-white px-2 py-1 z-40 rounded opacity-0 group-hover:opacity-100 transition">
                      Grid view
                    </span>
                  </div>
                  <div
                    className="relative group p-1 rounded-md"
                    style={{
                      border: screenView === "list" ? "1px solid #0088ff" : "",
                    }}
                  >
                    <TfiViewList
                      size={20}
                      className="cursor-pointer"
                      onClick={() => setScreenView("list")}
                      color={screenView === "list" ? "#0088ff" : ""}
                    />
                    <span className="absolute top-10 left-1/2 -translate-x-1/2 w-[max-content] text-xs bg-gray-800 text-white px-2 py-1 rounded z-40 opacity-0 group-hover:opacity-100 transition">
                      Table view
                    </span>
                  </div>
                  <button
                    style={{
                      backgroundColor: mode === "light" ? "white" : "#181818",
                    }}
                    className="hover:outline hover:outline-blue-500 hover:outline-[1px]  p-1 hover:text-blue-500 rounded-sm"
                    onClick={() => setIsExpanded(true)}
                  >
                    <CiSearch size={20} />
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        {view.first === "all" && screenView === "grid" ? (
          <div className="w-full">
            <AllReporteesGrid
              searchTerm={searchTerm}
              employeeData={employeeData}
              shiftStart={shiftStart}
              shiftEnd={shiftEnd}
            />
          </div>
        ) : (
          <></>
        )}
        {view.first === "all" && screenView === "list" ? (
          <>
            <AllReporteesTable
              searchTerm={searchTerm}
              employeeData={employeeData}
              shiftStart={shiftStart}
              shiftEnd={shiftEnd}
            />
          </>
        ) : (
          <></>
        )}

        {view.first === "direct" && screenView === "grid" ? (
          <>
            <DirectReporteesGrid
              searchTerm={searchTerm}
              employeeData={employeeData}
              shiftStart={shiftStart}
              shiftEnd={shiftEnd}
            />
          </>
        ) : (
          <></>
        )}
        {view.first === "direct" && screenView === "list" ? (
          <>
            <DirectReporteesTable
              searchTerm={searchTerm}
              employeeData={employeeData}
              shiftStart={shiftStart}
              shiftEnd={shiftEnd}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
